<template>
  <div class="page-wrapper">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.projectFid"  placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select v-model="searchData.feedbackName" placeholder="反馈来源">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in monthList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <DatePicker style="width:100%" v-model="searchData.createTime" format="yyyy-MM-dd" split-panels type="daterange" placeholder="创建日期筛选"></DatePicker>
        </Col>
        <Col span="5">
          <Input placeholder="用户名、手机号" v-model="searchData.condition"></Input>
        </Col>
      </Row>
    </search-group>

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  // import {formatDateTime} from "../../../../../utils/format";
  import {formatDateTime} from "../../../utils/format";
  import TableList from 'components/TableList/index';
  import {mapGetters} from 'vuex'
  import {getOpinionFeedbackEnumv1,getOpinionlist} from "../../../api/feedback";
import { refund } from '../../../api/book';

  export default {
    condition:'advice',
    components: {
      SearchGroup,
      TableList,
    },
    mounted() {
      getOpinionFeedbackEnumv1().then(res=>{
        if(!res.data){
          return
        }
        this.monthList=res.data

      }).catch(error=>{})

      this.findData()


    },
    computed: {
      ...mapGetters(['projectList']),
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          condition:this.searchData.condition,
          projectFid: this.searchData.projectFid,
          startTime: f(this.searchData.createTime[0]),
          endTime:f(this.searchData.createTime[1]),
          feedbackName:this.searchData.feedbackName

        }
      }
    },
    watch: {
      projectList() {
        this.projectListData = this.projectList
      }
    },
    data() {
      return {
        infoN:0,
        itemData:null,
        projectListData:[],
        monthList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center',
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            key: 'projectName',
            width: 180,
          },

          {
            title: ' '
          },
          {
            title: "用户名",
            key: 'userName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '手机号',
            key: 'phone',
            width: 130,

          },
          {
            title: ' '
          },
          {
            title: "反馈类型",
            key: 'feedbackName',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatMoney(params.row['commissionPersonal']))
            // }
          },
          {
            title: ' '
          },        {
            title: "反馈信息",
            key: 'text',
            width: 396,
            className: 'feedback-text-container',
            render: (h, params) => {
              return h('div',[
                h('div',{
                  class:{
                    'feedback-text-wrapper':true,
                  },
                  style:{
                    '-webkit-line-clamp': params.row.expandText ? '4' : 'inherit'
                  }
                },params.row.text),
                h('Button',{
                    props:{
                      type:'text',
                      size:'small'
                    },
                    style:{
                      'display': params.row.expandTextButton ? 'block' : 'none',
                      'float':'right'
                    },
                    on:{
                      'click':() => {
                        this.changeTableRowTextExpandState(params.index)
                      }
                    }

                  },params.row.expandText ? '展开' : '收起')
              ])
            }
          },
          {
            title: ' '
          },
          {
            title: "反馈时间",
            key: 'createTime',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['createTime'],false))

            }
          },
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime:['',''],
          condition:'',
          feedbackName:''

        },
      }
    },
    methods: {
      getData(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        getOpinionlist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total

          res.data.rows = res.data.rows.map(item => {
           
            if(item.text.length > 120 ){
              item.expandText = true
              item.expandTextButton = true;
            }else{
              item.expandText = false;
              item.expandTextButton = false;
            }
            return item;
          })
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime:['',''],
          condition:'',
          feedbackName:''
        }
      },
      changeTableRowTextExpandState(i){
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      }
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>